import { createReducer, createNamespacer } from "../commons/js/utils/reducer";
import { fromPairs as _fromPairs } from 'lodash';

const namespacers = {
    changePassword: createNamespacer("USER_CHANGE_PASSWORD"),
}

const initialstate = {
    currentPassword: {
        value: '',
        error: '',
        showError: '',
    },
    newPassword: {
        value: '',
        error: '',
        showError: '',
    },
    confirmPassword: {
        value: '',
        error: '',
        showError: '',
    },
    error: '',
}

const changePasswordReducer = createReducer(initialstate, {
    [namespacers.changePassword("SET_CURRENT_PASSWORD")]: (state, action) => {
        return {
            ...state,
            currentPassword: {
                ...state.currentPassword,
                value: action.payload.value,
            },
        }
    },
    [namespacers.changePassword("SET_NEW_PASSWORD")]: (state, action) => {
        return {
            ...state,
            newPassword: {
                ...state.newPassword,
                value: action.payload.value,
            },
        }
    },

    [namespacers.changePassword("SET_CONFIRM_PASSWORD")]: (state, action) => {
        return {
            ...state,
            confirmPassword: {
                ...state.confirmPassword,
                value: action.payload.value,
            },
        }
    },

    [namespacers.changePassword("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },

    [namespacers.changePassword("CLEAR_FORM")]: (state, action) => {
        return {
            ...state
            , currentPassword : {
                ...initialstate.currentPassword,
            }, newPassword : {
                ...initialstate.newPassword,
            }, confirmPassword: {
                ...initialstate.confirmPassword,
            }
        }
    },
    [namespacers.changePassword("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
})

export default changePasswordReducer;

